
export enum SexoEnum {
  Masculino = 'Masculino',
  Feminino = 'Feminino',
  Indefinido = 'Indefinido',
}
